import { tEngine } from "../../i18n/engine";
import { t as tr } from "../../i18n";
import { fmt, type CheckResult } from "@tasduvar/engine";
import { RatioBar } from "./RatioBar";

const OK = "text-[#1D7A46]", BAD = "text-[#B42318]";
/** CadTable hücresi (README §2.4): 44×5 çubuk · mono sayı sağa yaslı · ✓/✗; hüküm 10 px tek satır, tam metin başlıkta */
function CadCell({ ratio, ok, num, verdict, label }: { ratio: number; ok: boolean; num: string; verdict: string; label: string }): JSX.Element {
  return (
    <td className="align-top px-1 py-0.5">
      <div className="flex items-center gap-1.5"><RatioBar cad ratio={ratio} ok={ok} label={label} /><span className="font-mono tabular-nums text-[11px] flex-1 text-right">{num}</span><span aria-hidden className={ok ? OK : BAD}>{ok ? "✓" : "✗"}</span></div>
      <div className={`text-[10px] truncate ${ok ? "text-cad-ink3" : BAD}`} title={verdict}>{verdict}</div>
    </td>
  );
}

/** Bilgi amaçlı (hüküm vermeyen) klasik GK rozeti — gri */
export const InfoBadge = (): JSX.Element => <span className="px-1 rounded bg-[#E9ECF2] text-[#5B6270] text-[10px] leading-4 whitespace-nowrap" title={tr("Bilgi amaçlı (hüküm TBDY dayanım katsayılarıyla)")}>{tr("bilgi")}</span>;

/** `brief`: ücretsiz katman — gerekçe satırındaki ara değerler (Edev, Vth, qo…) gizlenir, yalnız hüküm kalır. */
const verdictOnly = (v: string): string => v.split(" — ")[0]!;
export function CheckCell({ check, mode, label, cad, brief }: { check: CheckResult | undefined; mode: "tbdy" | "classic"; label: string; cad?: boolean; brief?: boolean }): JSX.Element {
  const vt = (v: string): string => (brief ? verdictOnly(tEngine(v)) : tEngine(v));
  if (!check) return <td className="text-xs text-stone">—</td>;
  if (mode === "tbdy") {
    if (!check.tbdy) return <td className="text-xs text-stone">{tr("Yönetmelik kuralı yok (yalnız GK)")}</td>;
    const t = check.tbdy;
    if (cad) return <CadCell ratio={t.ratio} ok={t.ok} num={fmt(t.ratio, 2)} verdict={vt(t.verdict)} label={`${label} oran`} />;
    return (
      <td className="align-top py-1">
        <div className="flex items-center gap-2"><RatioBar ratio={t.ratio} ok={t.ok} label={`${label} oran`} /><span className="num text-xs w-12 text-right">{fmt(t.ratio, 2)}</span><span aria-hidden>{t.ok ? "✓" : "✗"}</span></div>
        <div className={`text-[11px] ${t.ok ? "text-ink/75" : "text-bad"}`}>{vt(t.verdict)}</div>
      </td>
    );
  }
  const c = check.classic;
  // TBDY'de klasik GK hüküm vermiyorsa (classicGoverns kapalı): değer görünür, ✓/✗ ve kırmızı yerine gri "bilgi" rozeti
  if (c.informative) {
    const detail = brief ? "" : tEngine(c.verdict).split(" — ").slice(1).join(" — ");
    const muted = cad ? "text-cad-ink3" : "text-stone";
    return (
      <td className={`align-top ${cad ? "px-1 py-0.5" : "py-1"}`} data-informative="true">
        <div className="flex items-center gap-1.5"><span className={`font-mono tabular-nums ${cad ? "text-[11px]" : "text-xs"} flex-1 text-right ${muted}`}>GK {fmt(c.factor, 2)}</span><InfoBadge /></div>
        <div className={`${cad ? "text-[10px] truncate" : "text-[11px]"} ${muted}`} title={detail || undefined}>{detail || tr("Bilgi amaçlı (hüküm TBDY dayanım katsayılarıyla)")}</div>
      </td>
    );
  }
  const ratio = Number.isFinite(c.factor) ? c.target / c.factor : 0;
  if (cad) return <CadCell ratio={ratio} ok={c.ok} num={`GK ${fmt(c.factor, 2)}`} verdict={vt(c.verdict)} label={`${label} GK`} />;
  return (
    <td className="align-top py-1">
      <div className="flex items-center gap-2"><RatioBar ratio={ratio} ok={c.ok} label={`${label} GK`} /><span className="num text-xs whitespace-nowrap">GK {fmt(c.factor, 2)}</span><span aria-hidden>{c.ok ? "✓" : "✗"}</span></div>
      <div className={`text-[11px] ${c.ok ? "text-ink/75" : "text-bad"}`}>{vt(c.verdict)}</div>
    </td>
  );
}
